import React, { MouseEvent, FC, useMemo } from "react";
import { ButtonType, UiButtonProps } from "./types";
import styles from "./ui-button.module.css";
import {
  TemplateType,
  ButtonRoundedClass,
  ButtonRoundedEnum } from
"@commons-monorepo/index";

const UiButton: FC<UiButtonProps> = ({
  appearance = "normal",
  isFilled = false,
  isWhite = false,
  isBlack = false,
  isSecondary = false,
  isTertiary = false,
  isSpecial = false,
  link = false,
  specialShortCase = false,
  size = "normal",
  hasPersonalization,
  className,
  disabled,
  isLoading,
  children,
  leftIcon,
  rightIcon,
  onClick,
  theme,
  styles: customStyles
}) => {
  const rounded = useMemo(
    () =>
    theme?.config?.button?.rounded === ButtonRoundedEnum.full ?
    ButtonRoundedClass.rounded :
    theme?.config?.button?.rounded === ButtonRoundedEnum.semi ?
    ButtonRoundedClass.mid_rounded :
    theme?.config?.button?.rounded === ButtonRoundedEnum.square ?
    ButtonRoundedClass.square :
    "",
    [theme]
  );

  const buttonType =
  theme?.template?.BUTTON === TemplateType.BUTTON_1 ?
  ButtonType.Button1 :
  theme?.template?.BUTTON === TemplateType.BUTTON_2 ?
  ButtonType.Button2 :
  ButtonType.Button1;

  const handleClick = (e?: MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) onClick(e);
  };

  return (
    <button
      type='button'
      className={`
				${styles.buttonWrapper} 
				${styles[buttonType]} 
				${styles[rounded]} 
				${styles[appearance]} 
				${styles[size]} 
				${hasPersonalization && styles.withPersonalization} 
				${isFilled && styles.hasFill} 
				${isWhite && styles.isWhite}
				${isBlack && styles.isBlack} 
				${isSecondary && styles.isSecondary}
				${isTertiary && styles.isTertiary}
				${isSpecial && styles.isSpecial}
        ${link && styles.link}
        ${specialShortCase && styles.specialShortCase}
				${className}
			`}
      role={"button"}
      disabled={disabled}
      style={{ ...customStyles }}
      onClick={handleClick}>

      {!isLoading && leftIcon}
      {!!children ? !isLoading ? children : <div /> : null}
      {!isLoading && rightIcon}
    </button>);

};

export default UiButton;